<template>
  <el-dialog :visible.sync="visibleFlag" :destroy-on-close="true" width="766px">
    <template slot="title">
      <div class="text-large font-normal leading-22 text-theme-black-850">添加审核员</div>
    </template>
    <div class="add-audit-content flex overflow-auto h-96">
      <!-- 左半部分 -->
      <div class="select-user flex flex-col px-6 overflow-auto box-border">
        <p class="text-medium-x font-semibold leading-22 text-theme-black-850 mb-4">已选用户</p>
        <article class="text-medium font-normal leading-24 bg-card-bg-gray px-4 py-3">
          <p class="text-theme-black-850">说明：</p>
          <p class="text-theme-black-650">同一层级内存在多名审批人时，一名审批人同意或拒绝即可</p>
        </article>
        <ul class="overflow-y-auto pt-6">
          <li class="flex justify-between leading-22 h-9" v-for="(item, index) in selectList" :key="item.id">
            <span class="text-theme-black-650"
              >{{ item.name }}
              <span v-if="item.mobile && item.staffType !== 2" class="text-theme-black-650">({{ item.mobile }})</span></span
            >
            <span class="text-theme cursor-pointer" @click="onClickDelUser(index)">删除</span>
          </li>
        </ul>
      </div>
      <article class="w-px h-96">
        <p style="backgroundcolor: #e7e9eb; height: calc(100% - 6px)"></p>
      </article>
      <!-- 右半部分 -->
      <dygc-user v-model="selectList" ref="dygcUser" />
    </div>
    <template slot="footer">
      <div class="text-right">
        <el-button class="normal-button" @click="onClickCancel" size="small">取消</el-button>
        <span class="ml-3">
          <el-button class="normal-button" type="primary" @click="onClickConfirm" size="small">确定</el-button>
        </span>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getStaffs } from '@/api/wenjuan/user'
import DygcUser from '@/components/dygc-user/DygcUser'

export default {
  name: 'AddAuditDialog',
  components: { DygcUser },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // companyId: {
    //   type: Number,
    //   default: ''
    // },
    companyUser: {
      type: Object,
      default: () => ({})
    },
    levelId: {
      type: String,
      default: ''
    },
    confirmHandler: Function,
    selectUserList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      hash: new Map(),
      selectList: []
    }
  },
  computed: {
    visibleFlag: {
      get() {
        return this.visible
      },
      set(v) {
        if (!v) {
          this.beforeCloseHandler()
        }
        this.$emit('update:visible', v)
      }
    }
  },
  created() {
    this.selectList = this.selectUserList.slice()
  },
  methods: {
    onClickCancel() {
      this.visibleFlag = false
    },
    onClickConfirm() {
      let selects = this.selectList
      this.confirmHandler(selects).then(res => {
        this.onClickCancel()
      })
    },
    onClickDelUser(index) {
      let user = this.selectList[index]
      this.selectList.splice(index, 1)
      let id = user.id
    },
    beforeCloseHandler(done) {
      let ele = this.$refs.dygcUser
      ele.clearCheckedNodes()
      done && done()
    }
  },
  beforeDestroy() {
    this.hash.clear()
    this.hash = null
  },
  watch: {
    visibleFlag(v) {
      if (v) {
        this.selectList = this.selectUserList.slice()
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__header {
  background-color: #f5f7fa;
  @apply px-6 py-3 mb-6;
}
::v-deep .el-dialog__body {
  @apply p-0;
}
::v-deep .el-dialog__footer {
  @apply pr-6 py-4 border-t border-black border-opacity-10 border-solid;
}
.add-audit-content {
  & div {
    @apply flex-1;
  }
}
</style>
